import FormHelperText from '@mui/material/FormHelperText'
import { styled } from '@mui/material/styles'

// TODO: Apply design library styling
const HelpText = styled(FormHelperText)(() => ({}))

export default HelpText
